<template>
  <div class="earningReport" id="earning_report">
    <div class="report_header">
      <div class="logo_box">
        <img
          src="../../assets/images/yj/logo1.png"
          alt="logo"
          class="logo_img"
        />
        <div class="logo_text">{{ today }}</div>
      </div>
      <div class="header_center">
        <img
          class="header_center_img"
          src="../../assets/images/yj/trophy.png"
          alt="logo"
        />
        <div class="header_center_text">慧航升本助梦PK榜</div>
      </div>
      <div class="header_left">
        <div class="cat_box">
          <img
            class="cat_box_img"
            src="../../assets/images/yj/cat.png"
            alt="logo"
          />
          <div class="cat_box_text">助力更多学员圆梦本科</div>
        </div>
        <div class="date_box">{{ currentMonth }}</div>
      </div>
    </div>
    <div class="content_box">
      <el-form class="flex" :model="form" ref="form">
        <el-form-item label="所属月份" prop="monthDate">
          <el-date-picker
            type="month"
            :clearable="false"
            v-model="form.monthDate"
            @change="teamChange"
            placeholder="所属月份"
            :disabled="isDisabled"
          >
          </el-date-picker>
        </el-form-item>
        <el-form-item label="所属上级" prop="superiorId">
          <el-select
            v-model="form.superiorId"
            filterable
            placeholder="请选择所属上级"
            @change="superiorChange"
            clearable
          >
            <el-option
              v-for="item in superiorList"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="所属小组" prop="teamId">
          <el-select
            v-model="form.teamId"
            :disabled="teamShow"
            filterable
            placeholder="请选择所属小组"
            @change="teamChange"
            clearable
          >
            <el-option
              v-for="item in teamList"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            >
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item prop="agreementState" class="state_style">
          <el-tooltip class="item" effect="dark" placement="bottom-start">
            <div slot="content" class="content_style">
              已完成协议(已勾选状态时):只针对绩效统计协议状态为无协议、已完成、线下签订三种状态的数据进行统计计算
            </div>
            <el-checkbox v-model="form.agreementState" @change="teamChange"
              >已完成协议</el-checkbox
            >
          </el-tooltip>
        </el-form-item>
        <el-button-group>
          <el-button @click="toSearch">
            <i class="el-icon-search"></i>
          </el-button>
          <el-button
            v-if="!isLoad1"
            :disabled="isLoad1"
            class="primary_style"
            @click="voiceContent"
          >
            <i class="el-icon-video-play"></i> 开启语音播报
          </el-button>
          <el-button v-else :disabled="true" type="primary">
            开启中
            <i class="el-icon-loading"></i>
          </el-button>
        </el-button-group>
        <el-popover
          placement="bottom"
          title="说明:"
          :width="340"
          trigger="click"
          class="popover"
        >
          <div>
            1.咨询老师：学员的所属业务老师<br />
            2.xxxx年-xx月招生目标：指定月内，咨询老师的指定招生目标<br />
            3.已完成：指定月内，咨询老师已完成的招生目标<br />
            4.目标距离（已完成比例）-距离：指定月内，咨询老师距离指定招生目标还差多少<br />
            5.目标距离（已完成比例）-完成度：指定月内，咨询老师完成了指定招生目标的百分之多少<br />
            6.业绩提成：指定月内，咨询老师已完成的招生目标所得的业绩总和
          </div>
          <template #reference>
            <el-button type="warning"
              ><i class="el-icon-question"></i> 说明
            </el-button>
          </template>
        </el-popover>
        <el-form-item label="排序" prop="orderByField" class="order_value">
          <el-select
            v-model="form.orderByField"
            filterable
            placeholder="请选择排序方式"
            @change="orderChange"
            clearable
          >
            <el-option
              v-for="item in orderList"
              :key="item.key"
              :label="item.value"
              :value="item.key"
            >
            </el-option>
          </el-select>
        </el-form-item>
      </el-form>
      <el-table
        :data="tableData"
        ref="multipleTable"
        id="course_record_list_table"
        :max-height="671"
        :empty-text="emptyText"
        border
        highlight-current-row
        class="table"
        v-loading="tableLoading"
        header-row-class-name="header-row-class-name"
        :cell-style="{ padding: '5px 0' }"
        :element-loading-text="loadingText"
        :header-cell-style="{
          backgroundImage: 'linear-gradient(to bottom, #ee5c4d,#c92d25)',
          borderColor: '#fdebbe',
          color: '#fdebbe',
          padding: '5px 0',
          userSelect: 'text',
        }"
        stripe
        style="width: 100%"
        show-summary
        :summary-method="getSummaries"
      >
        <el-table-column align="center" label="排名" width="100" type="index">
          <template slot-scope="scope">
            <img
              class="ranking"
              v-if="scope.$index + 1 === 1"
              src="../../assets/images/yj/one.png"
              alt="logo"
            />
            <img
              class="ranking"
              v-if="scope.$index + 1 === 2"
              src="../../assets/images/yj/two.png"
              alt="logo"
            />
            <img
              class="ranking"
              v-if="scope.$index + 1 === 3"
              src="../../assets/images/yj/three.png"
              alt="logo"
            />
            <span v-if="scope.$index + 1 > 3">{{ scope.$index + 1 }}</span>
          </template>
        </el-table-column>
        <el-table-column
          align="center"
          label="升本规划师"
          prop="adminName"
          :show-overflow-tooltip="true"
        ></el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          :label="monthDate + '月业绩目标'"
          prop="theMonthTarget"
          inputSearch="true"
        >
          <template slot-scope="scope">
            <span
              class="red"
              v-if="
                scope.row.completedTarget >= scope.row.theMonthTarget &&
                scope.row.theMonthTarget != 0
              "
              >{{ scope.row.theMonthTarget }}</span
            >
            <span v-else>{{ scope.row.theMonthTarget }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="月度业绩明细（单位：元）"
          inputSearch="true"
        >
          <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            label="本月新增业绩"
            prop="addAchievement"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.addAchievement || 0 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            label="本月退费业绩"
            prop="refundAchievement"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.refundAchievement || 0 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            label="本月实际业绩"
            prop="realityAchievement"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.realityAchievement || 0 }}</span>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="月度目标完成度"
          inputSearch="true"
        >
          <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            label="新增距离目标"
            prop="gapTarget"
            inputSearch="true"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.gapTarget || 0 }}</span>
            </template>
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            label="新增业绩完成度"
            prop="addCompletedPercent"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.addCompletedPercent || 0 }}%</span>
            </template>
          </el-table-column>
          <el-table-column
            :show-overflow-tooltip="true"
            align="center"
            label="实际业绩完成度"
            prop="realityCompletedPercent"
          >
            <template slot-scope="scope">
              <span>{{ scope.row.realityCompletedPercent || 0 }}%</span>
            </template>
          </el-table-column>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="新增业绩提成"
          prop="positiveCommission"
          inputSearch="true"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.positiveCommission }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="退扣提成"
          prop="negativeCommission"
          inputSearch="true"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.negativeCommission }}</span>
          </template>
        </el-table-column>
        <el-table-column
          :show-overflow-tooltip="true"
          align="center"
          label="实际提成"
          prop="businessCommission"
          inputSearch="true"
        >
          <template slot-scope="scope">
            <span>{{ scope.row.businessCommission }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
//引入接口
import {
  GetAchievementRankingList,
  GetSuperiorList,
  GetTeamBySuperior,
  GetBroadcastContent,
} from "../../network/earningReport";
import moment from "moment";
import { timeFormatNew } from "common/utils";

const speech = new SpeechSynthesisUtterance();
speech.rate = 1.5;
speech.volume = 1;
speech.pitch = 2;
const synth = window.speechSynthesis;
export default {
  name: "EarningReport",
  props: {
    tableMaxHeight: Number,
  },
  data() {
    return {
      form: {
        monthDate: "",
        superiorId: "",
        teamId: "",
        agreementState: "",
        orderByField: 1,
      },
      superiorList: [],
      teamList: [],
      emptyText: "暂无数据",
      tableData: [],
      slogans: [],
      tableLoading: false,
      loadingText: "loading...", //加载状态提示文本
      monthDate: "",
      endTime: "",
      voiceOption: "",
      dataTimer: null,
      voiceTimer: null,
      speakOption: "",
      flag: true,
      speech,
      synth,
      message: "",
      index: 0,
      firstPlay: true,
      teamShow: true,
      isLoad1: false,
      isResize: false,
      dataNew: [],
      orderList: [
        {
          key: 1,
          value: "按新增业绩排序",
        },
        {
          key: 2,
          value: "按本月实际业绩排序",
        },
        {
          key: 3,
          value: "按本月退费业绩排序",
        },
      ],
    };
  },
  computed: {
    today() {
      return moment().format("YYYY-M-DD");
    },
    currentMonth() {
      return (
        moment().startOf("month").format("YYYY-MM-DD") +
        "~" +
        moment().endOf("month").format("YYYY-MM-DD")
      );
    },
    isDisabled(){
      const sysdbaRoleIds = JSON.parse(sessionStorage.getItem("allConfig")).sysdbaRoleIds;
      const roleId = JSON.parse(sessionStorage.getItem("AdminCache")).rolesId
      const groupLeaderRoleId =  JSON.parse(sessionStorage.getItem("allConfig")).groupLeaderRoleId
      return !(sysdbaRoleIds.includes(roleId) || roleId == groupLeaderRoleId);
    }
  },
  mounted() {
    const app = document.querySelector("#app");
    // 去掉app上的style
    app.style.cssText = "";
  },
  created() {
    this.getMonth();
    this.getSuperiorList();
    // this.getOperationList();
    this.emptyText = "加载中";
    setTimeout(() => {
        if(sessionStorage?.getItem("AdminToken")){
            let adminInfo = sessionStorage?.getItem("AdminToken")
        ? JSON.parse(sessionStorage?.getItem("AdminToken"))
        : [];
      let expiresTime = adminInfo?.expires_in + new Date() / 1000;
      const token = {
        AccessToken: adminInfo?.access_token,
        AccessExpiresIn: expiresTime,
        RefreshToken: adminInfo?.refresh_token,
      };
      if(token) this.$store.commit("updateToken", token); 
      sessionStorage.removeItem("AdminToken"); //移除
        }
      this.getData();
    }, 2000);
    // this.miniScreen();
    // window.addEventListener("resize", () => {
    //     // 节流
    //     if (!this.isResize) {
    //         this.isResize = true;
    //         setTimeout(() => {
    //             this.miniScreen();
    //             this.isResize = false;
    //         }, 1000);
    //     }
    // });
  },
  methods: {
    // miniScreen() {
    //     if (document.documentElement.clientWidth < 1400) {
    //         document.documentElement.style.zoom = 0.68;
    //     } else {
    //         document.documentElement.style.zoom = 1;
    //     }
    // },
    // 列表合计
    getSummaries(param) {
      const { columns, data } = param;
      const sums = [];
      columns.forEach((column, index) => {
        if (index === 0) {
          sums[index] = "合计";
          return;
        }
        const values = data.map((item) => Number(item[column.property]));
        if (!values.every((value) => isNaN(value))) {
          sums[index] = values.reduce((prev, curr) => {
            const value = Number(curr);
            if (!isNaN(value)) {
              return prev + curr;
            } else {
              return prev;
            }
          }, 0);
          sums[index] = sums[index] > 0 ? sums[index].toFixed(2) : sums[index];
        } else {
          sums[index] = "/"; // 其余列一律不进行合计
        }
        // if (index !== 7 && index !== 8) {
        //     sums[index];
        // } else {
        //     sums[index] === '/' ? '/' : (sums[index]+= '%');
        // }
        if (index == 6) {
          sums[index] = this.dataNew.gapTargetCount;
        }
        if (index == 7) {
          sums[index] = this.dataNew.addCompletedPercentCount + "%";
        }
        if (index == 8) {
          sums[index] = this.dataNew.realityCompletedPercentCount + "%";
        }
        if (index == 9) {
          sums[index] = this.dataNew.positiveCommissionCount;
        }
        if (index == 10) {
          sums[index] = this.dataNew.negativeCommissionCount;
        }
        if (index == 11) {
          sums[index] = this.dataNew.achievementCount;
        }
      });
      return sums;
    },
    // 月份
    getMonth() {
      var now = new Date();
      var year = now.getFullYear(); //得到年份
      var month = now.getMonth() + 1; //得到月份
      var day = new Date(year, month, 0).getDate(); //获取当月最后一日
      month = month < 10 ? "0" + month : month;
      day = day < 10 ? "0" + day : day; //日数补 0
      var toMonth = year + "-" + month;
      this.form.monthDate = toMonth;
      // 月份
      this.monthDate = toMonth;
      // 年月日
      this.endTime = year + "-" + month + "-" + day;
    },
    monthChange(e) {
      this.monthDate = timeFormatNew(e, "yyyy-MM");
      var year = timeFormatNew(e, "yyyy");
      var month = timeFormatNew(e, "MM");
      var day = new Date(year, month, 0).getDate(); //获取当月最后一日
      this.endTime = year + "-" + month + "-" + day;
    },
    // 上级
    getSuperiorList() {
      GetSuperiorList().then(({ data: res }) => {
        if (res.code == 0) {
          this.$alert(res.message);
          return false;
        }
        this.superiorList = res.result;
        this.superiorList.unshift({ key: 0, value: "全部" });
        this.form.superiorId = this.superiorList[0].key;
        if (this.form.superiorId != 0) {
          this.getTeamList(this.form.superiorId);
        }
      });
    },
    superiorChange(e) {
      if (e && e != 0) {
        this.getTeamList(e);
      } else {
        this.teamList = [];
      }
      this.form.teamId = "";
      this.flag = false;
      this.teamShow = true;
    },
    // 排序值
    orderChange(e) {
      this.form.orderByField = e;
      this.getData();
    },
    teamChange() {
      this.flag = false;
    },
    // 小组
    getTeamList(e) {
      GetTeamBySuperior(e).then(({ data: res }) => {
        if (res.code == 0) {
          this.$alert(res.message);
          return false;
        }
        this.teamList = res.result;
        this.form.teamId = this.teamList[0].key;
        this.teamShow = false;
      });
    },
    toSearch() {
      this.flag = true;
      this.index = 0;
      this.voiceOption = [];
      this.firstPlay = true;
      clearInterval(this.dataTimer);
      clearTimeout(this.voiceTimer);
      this.synth?.cancel();
      this.monthChange(this.form.monthDate);
      this.getData();
    },
    // 列表数据
    async getData() {
      this.emptyText = "加载中";
      if (this.tableLoading) {
        return false;
      }
      this.tableLoading = true;
      this.loadingText = "loading...";
      let params = {
        monthDate:
          timeFormatNew(this.form.monthDate, "yyyy-MM") || this.form.monthDate,
        superiorId: this.form.superiorId || 0,
        teamId: this.form.teamId || null,
        agreementState: this.form.agreementState ? 2 : 0,
        orderByField: this.form.orderByField || null,
      };
      const res = await GetAchievementRankingList(params);
      this.tableLoading = false;
      if (res.code == 0) {
        this.emptyText = "暂无数据";
        this.$alert(result.msg);
        return false;
      }
      this.dataNew = res.result;
      this.tableData = res.result.achievements;
      this.slogans = res.result.slogans;
      this.emptyText = this.tableData ? "" : "暂无数据";
    },
    // 获取语音播报内容
    async voiceContent() {
      if (!this.form.teamId) {
        this.$message.error("请选择所属小组！");
      } else {
        if (!this.flag) {
          this.$message.error("请先点击搜索按钮！");
        } else {
          this.isLoad1 = true;
          const res = await GetBroadcastContent([this.form.teamId]);
          if (!res.data.code) {
            this.$alert(res.data.message);
            this.isLoad1 = false;
            return false;
          }
          this.isLoad1 = false;
          this.index = 0;
          this.synth = null;
          if (res.data.result.length <= 1 && res.data.result[0].studentCount == 0) {
            this.$message.warning("暂无待接入学员!");
          } else {
            this.voiceOption = res.data.result;
            this.voiceLoop();
            this.interfaceLoop();
          }
        }
      }
    },
    // 轮询接口
    interfaceLoop() {
      this.dataTimer = setInterval(() => {
        setTimeout(async () => {
          const res = await GetBroadcastContent([this.form.teamId]);
          if (!res.code) {
            this.$alert(res.message);
            return false;
          }
          this.index = 0;
          this.synth = null;
          if (res.result.length <= 1 && res.result[0].studentCount == 0) {
            this.$message.warning("暂无待接入学员!");
          } else {
            this.voiceOption = res.result;
            this.voiceLoop();
          }
        });
      }, 1200000);
    },
    // 循环播放语音
    voiceLoop() {
      this.voiceOption = this.voiceOption.filter(
        (item) => item.studentCount > 0
      );
      if (this.voiceOption.length <= 0) {
        this.$message.warning("暂无待接入学员!");
        return;
      }
      if (this.firstPlay) {
        this.firstPlay = false;
        this.speech.text = `你好，${
          this.voiceOption[this.index]?.adminName
        }老师，你有${
          this.voiceOption[this.index]?.studentCount
        }位待接入学员，请及时接入`;
        if (!this.synth) {
          this.synth = window.speechSynthesis;
        }
        this.synth.speak(this.speech);
        this.index++;
        if (this.index >= this.voiceOption.length) {
          this.index = 0;
        }
      }
      this.voiceTimer = setTimeout(async () => {
        this.speech.text = `你好，${
          this.voiceOption[this.index]?.adminName
        }老师，你有${
          this.voiceOption[this.index]?.studentCount
        }位待接入学员，请及时接入`;
        if (!this.synth) {
          this.synth = window.speechSynthesis;
        }
        await this.synth.speak(this.speech);
        this.index++;
        if (this.index >= this.voiceOption.length) {
          this.index = 0;
        }
        this.voiceLoop();
      }, 6000);
    },
  },
  destroyed() {
    clearTimeout(this.voiceTimer);
    clearInterval(this.dataTimer);
  },
};
</script>

<style lang="scss" scoped>
.earningReport {
  width: 100%;
  max-height: max-content;
  height: 100%;
  min-height: 100vh;
  background-image: url("../../assets/images/yj/bjImg1.png");
  background-repeat: no-repeat;
  background-size: 100% 100%;
  background-position: center center;
  .report_header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    flex-wrap: wrap;
    padding: 19px 58px 0;
    box-sizing: border-box;
    height: 116px;
    .logo_box {
      display: flex;
      flex-direction: column;
      justify-content: space-between;
      height: 80px;
      margin-top: 20px;
      .logo_img {
        width: 343px;
      }
      .logo_text {
        text-align: center;
        font-size: 24px;
        color: #fdebbe;
        font-weight: bold;
      }
    }
    .header_center {
      display: flex;
      align-items: center;
      justify-content: center;
      position: relative;
      .header_center_img {
        margin-bottom: -39px;
        margin-right: 49px;
        position: absolute;
        left: -147px;
      }
      .header_center_text {
        color: #fdebbe;
        font-size: 44px;
        margin-left: 10px;
        font-weight: bold;
      }
    }
    .header_left {
      .cat_box {
        display: flex;
        align-items: center;
        .cat_box_img {
          width: 49px;
          height: 49px;
          margin-right: 10px;
        }
        .cat_box_text {
          font-size: 20px;
          color: #fdebbe;
        }
      }
      .date_box {
        width: 294px;
        height: 35px;
        border-radius: 50px;
        background-image: linear-gradient(to bottom, #fdebbe, #f6bf7c);
        text-align: center;
        line-height: 35px;
        color: #aa2123;
        font-size: 17px;
        font-weight: bold;
      }
    }
  }
  .content_box {
    width: 100%;
    // height: 100%;
    max-height: max-content;
    // height: calc(100vh - 110px);
    padding: 40px 58px 35px;
    box-sizing: border-box;
    // margin-top: -10px;
    z-index: 99;
    background-image: url("../../assets/images/yj/border.png");
    background-repeat: no-repeat;
    background-size: 100% 100%;
    position: relative;
    .el-table {
      overflow-y: hidden !important;
      .ranking {
        width: 40px;
        height: 27px;
      }

      ::v-deep .custom-header-row {
        user-select: text !important;
      }
    }
  }
}
#earning_report {
  // padding: 20px;
  box-sizing: border-box;
  width: 100%;
}

#course_record_list_table {
  margin-top: 18px;
}

.flex {
  display: flex;
  justify-content: flex-start;
  margin: 0 0 10px 0;
}

.state_style {
  margin: 0 10px 0 0;
}

.content_style {
  width: 200px;
}

.el-form-item {
  display: flex;
  margin: 0 10px 0 0;
}

.primary_style {
  color: #fff;
  background-color: #409eff;
  border-color: #409eff;
}

.header {
  width: 100%;
  background: repeating-linear-gradient(to right, #ff3353, #ff6f43);
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
  margin-bottom: 2px;

  .logo_style {
    position: absolute;
    left: -20px;
  }

  .title {
    font-size: 22px;
    color: red;
    top: 72px;
    position: absolute;
  }
}

.footer {
  background: repeating-linear-gradient(to right, #ff3353, #ff6f43);
  display: flex;
  color: #fff;
  align-items: center;
  height: 30px;
  overflow: hidden;
  position: relative;

  .footer_left {
    padding: 0 20px 0 10px;
    box-sizing: border-box;
    width: 115px;

    .margin_right {
      margin-right: 5px;
    }
  }

  .line {
    border-right: 1px solid #fff;
    height: 30px;
  }

  .footer_right {
    text-align: center;
    width: 100%;
  }

  .footer_right_scroll {
    text-align: center;
    width: 100%;
    animation: scroll 10s linear infinite;
    position: absolute;
    top: 0;
  }

  .footer_right_scroll:hover {
    animation-play-state: paused;
  }

  @keyframes scroll {
    0% {
      transform: translateY(0);
    }

    100% {
      transform: translateY(-100%);
    }
  }
}

.table_title {
  width: 100%;
  // background: #ececec;
  background-image: linear-gradient(to bottom, #ee5c4d, #c92d25);
  color: #fdebbe;
  text-align: center;
  font-weight: bold;
  padding: 5px 0;
  margin-top: 10px;
}

.red {
  color: red;
}

@media screen and (max-height: 768px) {
  .el-table {
    max-height: 768px !important;
    min-height: 100% !important;
    ::v-deep .el-table__body-wrapper {
      max-height: calc(100% - 115px) !important;
    }
  }
  .earningReport {
    // height: 100%;
    height: max-content;
  }
  .content_box {
    max-height: max-content;
    min-height: 100vh;
  }
}
@media screen and (max-width: 1400px) {
  .el-table {
    zoom: 0.9;
  }
}
.order_value {
  margin-left: 20px;
}
</style>
